module.exports = __webpack_public_path__ + "img/registerBanner.e73f0cfe.png";